import React from "react";

const Achievement = () => {
    return(
        <svg 
         version="1.0" 
         xmlns="http://www.w3.org/2000/svg" 
         className="me-2"
         width="22" 
         height="22" 
         viewBox="0 0 512.000000 512.000000"
         preserveAspectRatio="xMidYMid meet">
            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            fill="#FFFFFF" stroke="none">
                <path d="M900 5109 c-41 -16 -80 -60 -91 -102 -7 -25 -8 -80 -3 -148 l7 -109
                -349 0 c-394 0 -397 -1 -442 -76 -22 -38 -23 -44 -17 -199 19 -520 128 -971
                331 -1378 305 -609 757 -983 1267 -1046 l77 -9 87 -82 c47 -45 122 -107 165
                -137 l78 -55 0 -334 0 -334 -167 0 c-115 0 -185 -5 -223 -15 -190 -50 -345
                -204 -395 -391 -10 -36 -18 -124 -22 -226 l-6 -166 -35 -7 c-45 -8 -97 -59
                -110 -108 -19 -68 19 -146 84 -173 50 -21 2798 -21 2848 0 65 27 103 105 84
                173 -13 49 -65 100 -110 108 l-35 7 -6 166 c-4 102 -12 190 -22 226 -50 187
                -205 341 -395 391 -38 10 -108 15 -222 15 l-168 0 0 334 0 334 78 55 c43 30
                118 92 165 137 l87 82 77 9 c510 63 962 437 1267 1046 203 407 312 858 331
                1378 6 155 5 161 -17 199 -45 75 -48 76 -440 76 l-348 0 2 134 c3 147 -2 162
                -66 210 -27 21 -28 21 -1674 23 -1078 1 -1656 -2 -1672 -8z m3106 -451 c-38
                -925 -312 -1817 -714 -2321 -410 -516 -913 -567 -1342 -137 -465 465 -794
                1433 -836 2458 l-7 162 1453 0 1453 0 -7 -162z m-3174 -293 c49 -522 162
                -1022 328 -1440 53 -134 159 -357 215 -452 20 -35 33 -63 28 -63 -4 0 -49 21
                -99 46 -522 262 -929 1022 -989 1844 -3 47 -8 100 -11 118 l-5 32 263 -2 263
                -3 7 -80z m3984 53 c-3 -18 -8 -71 -11 -118 -53 -725 -375 -1406 -824 -1743
                -64 -48 -242 -147 -264 -147 -5 0 8 28 28 63 56 95 162 318 215 452 163 413
                287 954 326 1425 3 47 8 88 11 93 2 4 121 7 264 7 l260 0 -5 -32z m-2416
                -2798 c25 -5 97 -10 160 -10 63 0 135 5 160 10 25 6 55 12 68 15 l22 5 0 -270
                0 -270 -250 0 -250 0 0 270 0 270 23 -5 c12 -3 42 -9 67 -15z m1075 -842 c45
                -25 96 -78 116 -123 15 -33 19 -67 19 -197 l0 -158 -1050 0 -1050 0 0 158 c0
                188 10 217 92 290 59 53 37 52 973 49 790 -2 873 -4 900 -19z"/>
            </g>
        </svg>
    )
};

export default Achievement;